import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PostAdSuccess.css';

const PostAdSuccess: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/my-ads');
  };

  return (
    <div className="post-ad-success-container">
      {/* Notification Banner */}
      <div className="post-ad-success-notification">
        <div className="notification-content">
          <div className="notification-icon">
            <div className="notification-dot"></div>
          </div>
          <div className="notification-text">
            <div className="notification-title">Your New P2P Buy Offer is Live!</div>
            <div className="notification-subtitle">You have created a new offer.</div>
          </div>
        </div>
      </div>

      <div className="post-ad-success-content">
        {/* Success Icon with Green Glow */}
        <div className="success-icon-wrapper">
          <div className="success-glow-outer"></div>
          <div className="success-glow-inner"></div>
          <div className="success-icon-container">
            <svg 
              width="36" 
              height="36" 
              viewBox="0 0 36 36" 
              fill="none"
              className="success-icon"
            >
              <path 
                d="M30 9L13.5 25.5L6 18" 
                stroke="currentColor" 
                strokeWidth="3" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>

        {/* Success Heading */}
        <h1 className="success-heading">
          Offer Successfully Posted!
        </h1>

        {/* Success Message */}
        <p className="success-message">
          Your offer is now visible to all traders on the platform
        </p>

        {/* Go Back Button */}
        <button 
          className="go-back-button"
          onClick={handleGoBack}
        >
          Go back
        </button>
      </div>
    </div>
  );
};

export default PostAdSuccess;